import { VALID_DIGITS } from "../constants.js";
var PLUS_SIGN = "+", RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")", RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$", RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g"), ALPHANUM_ = VALID_DIGITS, RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*", VALID_ALPHA_ = "a-zA-Z", RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*", RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$", RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g"), RFC3966_PREFIX_ = "tel:", RFC3966_PHONE_CONTEXT_ = ";phone-context=", RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0)
    return null;
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length)
    return "";
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  return phoneContextEnd >= 0 ? numberToExtractFrom.substring(phoneContextStart, phoneContextEnd) : numberToExtractFrom.substring(phoneContextStart);
}
function isPhoneContextValid(phoneContext) {
  return phoneContext === null ? !0 : phoneContext.length === 0 ? !1 : RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
export {
  PLUS_SIGN,
  RFC3966_ISDN_SUBADDRESS_,
  RFC3966_PHONE_CONTEXT_,
  RFC3966_PREFIX_,
  extractPhoneContext as default,
  isPhoneContextValid
};
//# sourceMappingURL=extractPhoneContext.js.map
